import React, { useEffect, useState, useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import styled from 'styled-components'

import Select from '../../../../components/dashboard/controls/Select'
import MainModal from '../../../../components/dashboard/modal/MainModal'
import ModalHead from '../../../../components/dashboard/modal/ModalHead'
import { SingleDropdownSelect } from '../../../../components/dashboard/TalentPool/DropdownSelect'
import Flex from '../../../../components/layouts/Flex'

import status from '../../../../constant/interviewStatus'

import useMutation from '../../../../hooks/useMutation'

import { setModal } from '../../../../store/actions/listsActions'
import {
  setRecruiters,
  setUpdatedStage,
  setApplicants,
  setRefreshList,
  setSelectedInterview,
} from '../../../../store/actions/recruitersActions'
import { getTalent } from '../../../../store/actions/talentActions'

import { P } from '../../../../style/Typography.style'

import axiosInstance from '../../../../services/config/AxiosIntance'

const UpdateStage = () => {
  const { addToast } = useToasts()
  const dispatch = useDispatch()
  const { selectedInterview, recruiters, applicants } = useSelector(
    (state) => state.requisitions
  )

  const { modal } = useSelector((state) => state.lists)

  const { data, error, handleRequest, loading, success } = useMutation()

  const [allStages, setAllStages] = useState([])
  const [stage, setStage] = useState(0)
  const [stages, setStages] = useState([])
  const [applicantStatus, setApplicantStatus] = useState('')
  const [recruiter, setRecruiter] = useState('')
  const [calendarUrls, setCalendarUrls] = useState([])
  const [selectedUrl, setSelectedUrl] = useState('')
  const [currStage, setCurrStage] = useState(0)

  useEffect(() => {
    axiosInstance
      .get('/stages')
      .then((res) => {
        const result = res?.data?.result
        if (result.length) {
          const filteredStages = result
            .filter((stage) => stage.order > selectedInterview?.stageOrder)
            .map((stage) => ({
              value: stage.id,
              label: stage.name,
            }))
          setAllStages(result)
          setStage(parseInt(filteredStages[0].value))
          setStages(filteredStages)

          const currStage = result.filter(
            (val) => val.id === selectedInterview?.stage_id
          )[0].code
          setCurrStage(currStage)
        }
      })
      .catch((error) => {
        if (error) {
          addToast(
            error?.response?.data?.message ||
            error?.response?.message ||
            'Something went wrong',
            {
              appearance: 'error',
              autoDismiss: true,
            }
          )
        }
      })
    setApplicantStatus(status[0].value)
    setRecruiter(selectedInterview?.recruiter_id)
  }, [selectedInterview])

  const handleSelectRecruiter = (e) => {
    setRecruiter((prevState) => {
      return {
        ...prevState,
        recruiter_id: e.target.value,
        recruiter_name: e.target.label,
      }
    })
    setSelectedUrl('')
  }

  const handleSelectCalendarUrl = (e) => {
    setSelectedUrl(e.target.value)
  }

  const getStageId = useCallback(
    (name) => {
      if (allStages.length) {
        return parseInt(allStages.filter((stage) => stage.name === name)[0].id)
      }
      return 0
    },
    [allStages]
  )

  const handleUpdateStage = () => {
    if (stage === getStageId('1st Interview')) {
      if (!selectedUrl) {
        return addToast('Calendly Url field is required.', {
          appearance: 'error',
          autoDismiss: true,
        })
      }
    }

    if (stage !== getStageId('Closed')) {
      if (!recruiter?.recruiter_id)
        return addToast('Please select an interviewer', {
          appearance: 'error',
          autoDismiss: true,
        })

      const data = {
        recruiter_id: recruiter.recruiter_id.toString(),
        applicant_id: selectedInterview.applicant_id.toString(),
        job_id: selectedInterview.job_id.toString(),
        stage_id: stage,
        calendar_url: selectedUrl,
      }

      handleRequest(
        `/interviews/${selectedInterview.id}/update-stage`,
        data,
        'PUT'
      )
    } else {
      if (applicantStatus === 'Accepted') {
        dispatch(setModal([...modal, 'acceptApplicant']))
      } else if (applicantStatus === 'Rejected') {
        dispatch(setModal([...modal, 'rejectApplicants']))
      }
    }
  }

  const handleSelectStage = (e) => {
    const value = parseInt(e.target.value)
    setStage(value)

    let userTypeParams = [1]

    if (value !== getStageId('1st Interview')) {
      userTypeParams = [1, 5]
    }

    axiosInstance
      .get(`/users/all?userTypeId=${JSON.stringify(userTypeParams)}`)
      .then((res) => {
        dispatch(setRecruiters(res?.data?.resp))
      })
  }

  const handleSelectApplicantStatus = (e) => {
    setApplicantStatus(e.target.value)
  }

  const handleClose = () => {
    const modals = modal.slice(0, -1)
    dispatch(setModal(modals))
  }

  useEffect(() => {
    if (data) {
      addToast(data.message, {
        appearance: 'success',
        autoDismiss: true,
      })

      const appIdx = applicants.findIndex(
        (a) => a.applicant_id === selectedInterview.applicant_id
      )
      const newApplicantList = applicants.filter(
        (a) => a.applicant_id !== selectedInterview.applicant_id
      )

      if (newApplicantList.length > 0) {
        dispatch(getTalent(newApplicantList[appIdx].applicant_id))
        dispatch(setApplicants(newApplicantList))
        const updatedModal = [
          ...modal.filter((item) => item !== 'editSchedule'),
        ]
        dispatch(setModal(updatedModal))
      } else {
        dispatch(setModal(''))
      }

      dispatch(setSelectedInterview(data?.resp))
      dispatch(setUpdatedStage(currStage))
      dispatch(setRefreshList(currStage))
    }
  }, [success])

  useEffect(() => {
    if (error) {
      addToast(
        error?.response?.data?.message ||
        error?.response?.message ||
        'Something went wrong',
        {
          appearance: 'error',
          autoDismiss: true,
        }
      )
    }
  }, [error])

  useEffect(() => {
    if (recruiter.recruiter_id) {
      axiosInstance
        .get(`/${recruiter.recruiter_id}/calendly_url`)
        .then((res) => {
          setCalendarUrls(res.data.data.calendly_urls)
        })
        .catch((err) => console.log(err))
    }
  }, [recruiter.recruiter_id])

  useEffect(() => {
    dispatch(setUpdatedStage(''))
    dispatch(setRefreshList(''))
  }, [])

  return (
    <>
      <MainModal
        buttonText="Update"
        loading={loading}
        onClick={handleUpdateStage}
        header={
          <ModalHead
            name={selectedInterview.applicantName}
            role={selectedInterview.role}
            onClose={handleClose}
          />
        }
      >
        <Flex direction="column" gap="0.4rem" margin="0 0 1rem 0">
          <P size="0.85rem">Stage</P>
          <Select
            height="2.5rem"
            onchange={(e) => handleSelectStage(e)}
            defaultValue={stage}
            options={stages}
            value={stage}
          />
        </Flex>

        {stage === getStageId('Closed') && (
          <Flex direction="column" gap="0.4rem" margin="0 0 1rem 0">
            <P size="0.85rem">Status</P>

            <Select
              height="2.5rem"
              onchange={(e) => handleSelectApplicantStatus(e)}
              defaultValue={applicantStatus}
              options={status}
              value={applicantStatus}
            />
          </Flex>
        )}

        {stage !== getStageId('Closed') && (
          <Flex direction="column" gap="0.4rem" margin="1rem 0 0 0">
            <SingleDropdownSelect
              onChange={(e) => {
                handleSelectRecruiter(e)
              }}
              title="Interviewer"
            >
              <option value="">Choose an option</option>
              {recruiters?.map((recruiter) => {
                if (recruiter?.name) {
                  return (
                    <option
                      key={recruiter?.id}
                      value={recruiter?.id}
                      data-recruiterName={recruiter?.name}
                    >
                      {recruiter?.name}
                    </option>
                  )
                }
                return null
              })}
            </SingleDropdownSelect>
          </Flex>
        )}

        {[getStageId('1st Interview'), getStageId('Coaching')].includes(
          stage
        ) && (
            <Flex direction="column" gap="0.4rem" margin="1rem 0 0 0">
              <SingleDropdownSelect
                onChange={(e) => {
                  handleSelectCalendarUrl(e)
                }}
                title="Calendly Url"
              >
                <option value="">Choose an option</option>
                {calendarUrls?.map((url, index) => {
                  return (
                    <option key={index} value={url}>
                      {url}
                    </option>
                  )
                })}
              </SingleDropdownSelect>
            </Flex>
          )}
      </MainModal>
    </>
  )
}

export default UpdateStage

export const DateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  &.mt {
    margin-top: 1rem;
  }

  .datetime-icon {
    position: absolute;
    bottom: 0.75rem;
    left: 0.75rem;
    font-size: 1rem;
    color: #aeb3c9;
    z-index: 1;
  }

  .date-picker {
    width: 100%;
    height: 2.5rem;
    border: 1px solid #aeb3c9;
    padding: 0 2rem;
    padding-left: 2.5rem;
    font-size: 0.75rem;
  }
`
